import { Table } from "common/Table/Table";
import { Fragment, useEffect, useState } from "react";
import UserService from "services/user.service";
import { formatPhone } from "./Contacts";
import { formatDate } from "utils/funcs";
import { useRouter } from "hooks/useRouter";

const service = new UserService();

export const BreezyData = () => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0)

    const { push } = useRouter()

  const columns = [
    { key: "first_name", dbColName: "candidate", title: "First name", render: d => d?.first_name },
    { key: "first_name", dbColName: "candidate", title: "Last name", render: d => d?.last_name }, 
    { key: "email", dbColName: "candidate", title: "email", render: d => d?.email },
    { key: "phone", dbColName: "candidate", title: "phone", render: d => formatPhone(d?.phone) },
    { key: "source", dbColName: "source", title: "source", render: s => s?.source_name },
    { key: "company", dbColName: "company", title: "company", render: c => c?.company_name },
    { key: "stage", dbColName: "stage", title: "stage", render: s => s?.stage_name },

    // { key: "zip_code", dbColName: "zip_code", title: "zip code" },
    // { key: "details", dbColName: "details", title: "details" },
    // { key: "to_badgeid", dbColName: "to_badgeid", title: "to badgeid" },
    { key: "createdAt", dbColName: "createdAt", title: "created At", render: date => formatDate(date) },
  ];

  const [pagination, setPagination] = useState({
    pageNumber: 1,
    limit: 100,
    startDate: '',
    endDate: '',
  })

  useEffect(() => {
    setLoading(true);
    service
      .getBreezyData(pagination)
      .then((resp) => {
        if(resp.data.success && resp.data.data) {
          setData(resp.data.data)
          setTotalItems(resp.data.totalDocument)
        } else {
          setData([])
        }
      })
      .catch((err) => {
        setData([])
      })
      .finally(() => {
        setLoading(false);
      });
  }, [pagination]);

  return (
    <Fragment>
      <div className="flex justify-between items-center">
      <div className="flex flex-col mb-4">
        <h1 className="page-title">
          Breezy Data
        </h1>
        <p className="page-subtitle">View all breezy data</p>
      </div>
      <button
          type="button"
          onClick={() => push("/breezy-stats")}
          className="btn-dark"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-5 w-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
            />
          </svg>
          <span>Breezy Stats</span>
        </button>
      </div>
      
      <Table
        data={data}
        loadingData={loading}
        pagination={pagination}
        setPagination={setPagination}
        setData={setData}
        columnFilters={
          <ColumnFilters
            pagination={pagination}
            setPagination={setPagination}
          />
        }
        totalItems={totalItems}
        columns={columns}
        exportButton={false}
      />
    </Fragment>
  );
};

const ColumnFilters = ({ pagination, setPagination }) => {
  return (
    <div className="flex gap-4 mt-2">
      <div className="flex-1">
        <label className="field-label">Start Date</label>
        <input
          className="w-full px-3 py-2 text-sm"
          type="date"
          value={pagination.startDate}
          onChange={(e) =>
            setPagination({
              ...pagination,
              startDate: e.target.value,
            })
          }
        />
      </div>

      <div className="flex-1">
        <label className="field-label">End Date</label>
        <input
          placeholder="Start date"
          className="w-full px-3 py-2 text-sm"
          type="date"
          value={pagination.endDate}
          onChange={(e) => {
            setPagination({
              ...pagination,
              endDate: e.target.value,
            });
          }}
        />
      </div>
    </div>
  );
};
